import React, { useEffect } from "react";

import { DataBoxGroup } from "@transfr-inc/dashboard-components";
import { getLearnerTerm } from "@transfr-inc/dashboard-components/constants";

const ChartFilter = {
  ActiveTrainees: {
    key: "activeTrainees",
    label: `Active ${getLearnerTerm({ plural: true })}`,
  },
  CertificatesAwarded: {
    key: "certificatesCompleted",
    label: "Certificates of Completion",
  },
  MicrocredentialsEarned: {
    key: "microCredentialsEarned",
    label: "Microcredentials",
  },
  BadgesAwarded: {
    key: "badgesEarned",
    label: "Badges",
  },
};

export function ProgramDataboxes({ data, onCategoryChange }) {
  const dataBoxConfig = [
    {
      label: ChartFilter.ActiveTrainees.label,
      key: ChartFilter.ActiveTrainees.key,
      alt: "Icon for a user avatar wearing a hardhat.",
      description: `${getLearnerTerm({
        plural: true,
      })} who have started at least one activity in the programs.`,
      className: "data-box",
      onClick: () => onCategoryChange(ChartFilter.ActiveTrainees),
    },
    {
      label: ChartFilter.CertificatesAwarded.label,
      key: ChartFilter.CertificatesAwarded.key,
      alt: "Icon for a user wearing a VR headset.",
      description: `Count of ${getLearnerTerm({
        plural: true,
      })} who have completed the programs and earned a Certificate of Completion.`,
      className: "data-box",
      onClick: () => onCategoryChange(ChartFilter.CertificatesAwarded),
    },
    {
      label: ChartFilter.MicrocredentialsEarned.label,
      key: ChartFilter.MicrocredentialsEarned.key,
      alt: "Icon for a medal.",
      description: `Count of Microcredentials awarded to ${getLearnerTerm({
        plural: true,
      })}.`,
      className: "data-box",
      onClick: () => onCategoryChange(ChartFilter.MicrocredentialsEarned),
    },
    {
      label: ChartFilter.BadgesAwarded.label,
      key: ChartFilter.BadgesAwarded.key,
      alt: "Icon for a badge.",
      description: `Count of Badges awarded to ${getLearnerTerm({
        plural: true,
      })}.`,
      className: "data-box",
      onClick: () => onCategoryChange(ChartFilter.BadgesAwarded),
    },
  ];

  useEffect(() => {
    dataBoxConfig[0].onClick();
  }, []);

  return (
    <DataBoxGroup data={data} dataBoxConfig={dataBoxConfig} className="rows" />
  );
}
